/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */
import { ItemMetadata } from '../utils/UNSAFE_dataProvider';

export const variants = ['banner', 'inline', 'toast'] as const;
export type MessageVariant = (typeof variants)[number];

export const severities = ['error', 'warning', 'confirmation', 'info', 'none'] as const;
export type MessageSeverity = (typeof severities)[number];

/**
 * Structure of data item passed to the renderer functions
 */
export type MessageRendererDataItem<K, D> = {
  /**
   * The data for the current message
   */
  data: D;

  /**
   * The key for the current message
   */
  key: K;

  /**
   * The metadata for the current message
   */
  metadata?: ItemMetadata<K>;
};
